import React from 'react';

const SparklesIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="m12 3-1.9 3.8-3.8 1.9 3.8 1.9L12 15l1.9-3.8 3.8-1.9-3.8-1.9L12 3z" />
    <path d="M5 11.5 3.5 8.5 2 11.5l-3 1.5 3 1.5L3.5 17.5 5 14.5l3-1.5-3-1.5z" />
    <path d="M22 11.5 20.5 8.5 19 11.5l-3 1.5 3 1.5L20.5 17.5 22 14.5l3-1.5-3-1.5z" />
  </svg>
);

export default SparklesIcon;
